export default __webpack_public_path__ + "static/media/bronze.76ff1d01.png";